import React, {useState, useEffect, useRef} from 'react';
import PillBadge from '../Badge/PillBadge';
import TutorialPopover from '../TutorialPopover/TutorialPopover';
import { getTutorialTipMeta } from '../../../utils/tutorialApi';
import axios from 'axios';
import {ImageAltStyled, JobViewStyled, OverflowContainerStyled, RuleStyled, SuitabilitySpanStyled} from "../../../styled/JobConnection";
import {useTheme} from "../Theme/ThemeContext";
import { FaHandshake } from "react-icons/fa6";
import {SiAnswer, SiReaddotcv, SiGmail} from "react-icons/si";
import { SlEnvolopeLetter } from "react-icons/sl";
import { FaLongArrowAltLeft } from 'react-icons/fa';
import Alert from '@mui/material/Alert';
import { IoIosUnlock } from "react-icons/io";
import { MdMarkEmailRead, MdDeleteForever, MdOutlineCancel} from "react-icons/md";
import { TbChecklist } from "react-icons/tb";
import { ThreeCircles } from 'react-loader-spinner';
import {useSelector} from "react-redux";
import { formatLargeText, parseAndValidateEmails, startAutoApply } from "../../../utils/client-functions";
import { useErrorSetter, useSuccessSetter, useInfoSetter } from '../../../hooks/useUiMessages';
import Accordion from "../Accordion/Accordion";
import ResumePricing from "../../Pricing/ResumePricing";
import { PlainModalOverlay } from '../../UI/Modal/Modal';
import AuthInput from '../../UI/Input/AuthInputs';
import { ButtonThin, ButtonSubmitGreen } from '../../UI/Buttons/Buttons.js';
import { FaRegCopy } from 'react-icons/fa';
import { copyText } from '../../../utils/client-functions';
import OvalSpinner from "../Spinners/OvalSpinner";






const JobView = (props) => {
    const {
        job,
        getJob,
        getResume,
        chooseActStr,
        deleteJob,
        setActiveIndex,
    } = props;
    const [matchLoading, setMatchLoading] = useState(false)
    const [pricingOpen, setPricingOpen] = useState(false);
    const [subbedForResumeScore, setSubbedForResumeScore] = useState(true);
    const [subbedForInsight, setSubbedForInsight] = useState(true);
    const [resumeScore, setResumeScore] = useState([ 
                    { title: "Resume Match", percentage: 0 },
                    { title: "Skills", percentage: 0 },
                    { title: "Exp Level", percentage: 0 },
                    { title: "Industry", percentage: 0 }
                ]);
    const [companyInsight, setCompanyInsight] = useState({});
    const [insightLoading, setInsightLoading] = useState(false);
    const [insiderOpen, setInsiderOpen] = useState(false);
    const [companyOpen, setCompanyOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [emailInput, setEmailInput] = useState('');
    const [retryingJob, setRetryingJob] = useState(null);
    const [deleteBorderColor, setDeleteBorderColor] = useState('crimson');

    const [snapshotId, setSnapshotId] = useState(null);
    const fetchedForJobRef = useRef(null);

    const { resumeSubDuration, isResumeSubbed } = useSelector((state) => state.stateData);
    const {themeName} = useTheme();
    const overflowRef = useRef(null);
    const [showTip, setShowTip] = useState(false);
    const tipTimerRef = useRef(null);
    const tipShownRef = useRef(false); // ensure tip opens only once per mount
    const headerAnchorRef = useRef(null);
    const [headerRect, setHeaderRect] = useState(null);
    const badgeAnchorRef = useRef(null);
    const [badgeRect, setBadgeRect] = useState(null);

    // Keep a live rect of the Job Information header so TutorialPopover can position correctly in JobHub.
    useEffect(() => {
        const updateRects = () => {
            try {
                if (headerAnchorRef.current && headerAnchorRef.current.getBoundingClientRect) {
                    setHeaderRect(headerAnchorRef.current.getBoundingClientRect());
                } else {
                    setHeaderRect(null);
                }
            } catch (_) { setHeaderRect(null); }
            try {
                if (badgeAnchorRef.current && badgeAnchorRef.current.getBoundingClientRect) {
                    setBadgeRect(badgeAnchorRef.current.getBoundingClientRect());
                } else {
                    setBadgeRect(null);
                }
            } catch (_) { setBadgeRect(null); }
        };

        updateRects();
        window.addEventListener('resize', updateRects);
        window.addEventListener('scroll', updateRects, { passive: true });
        return () => {
            try { window.removeEventListener('resize', updateRects); window.removeEventListener('scroll', updateRects); } catch(_) {}
        };
    }, [job, showTip]);

    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();
    const infoSetter = useInfoSetter();

    useEffect(() => {
        setInsiderOpen(false);
        setCompanyOpen(false);
        setCompanyInsight({});
        // Scroll only the OverflowContainerStyled div to top when job changes
        if (overflowRef.current) {
            overflowRef.current.scrollTop = 0;
        }
    }, [job]);

    // Listen for global job-updated events (triggered after a successful Try Again)
    useEffect(() => {
        const handler = (ev) => {
            try {
                const jid = ev?.detail?.jobId;
                const currentJobId = String(job?.id || job?.job_id || job?.jobId || '');
                if (!jid || !currentJobId) return;
                if (String(jid) === currentJobId) {
                    const linkUrl = job?.linkedin_url || job?.company_object?.linkedin_url || job?.url || job?.company_url || '';
                    const companySite = job?.external_url || job?.final_url || job?.url || '';
                    try { getJob(linkUrl, companySite, job?.applicants_count || job?.job_num_applicants, job); } catch(_) {}
                }
            } catch(_) {}
        };
        window.addEventListener('autoApply:jobUpdated', handler);
        return () => window.removeEventListener('autoApply:jobUpdated', handler);
    }, [job, getJob]);

        // Show tutorial tip 5s after a job tile is clicked (job prop changes)
        useEffect(() => {
            // clear any previous timer
            try { if (tipTimerRef.current) { clearTimeout(tipTimerRef.current); tipTimerRef.current = null; } } catch(_) {}
            // Only proceed if job has applied/attempted badge and tip hasn't been shown this mount
            const hasBadge = Boolean(job?.applied || job?.attemptedEmailAutoApply);
            if (!hasBadge) return;
            if (tipShownRef.current) return; // already shown once this mount
            // set timer to show tip after 5s, but first check persisted preference
            (async () => {
                try {
                    const tipKey = job?._id ? `job-badge-${job._id}` : null;
                    if (tipKey) {
                        const meta = await getTutorialTipMeta(tipKey);
                        if (meta && meta.dontShow) {
                            tipShownRef.current = true;
                            return;
                        }
                    }
                } catch (_) {}
                tipTimerRef.current = setTimeout(() => {
                    setShowTip(true);
                    tipShownRef.current = true;
                    tipTimerRef.current = null;
                }, 5000);
            })();
            return () => { try { if (tipTimerRef.current) { clearTimeout(tipTimerRef.current); tipTimerRef.current = null; } } catch(_) {} };
        }, [job]);

    useEffect(() => {
        // Create a stable key for the job so we only fetch once per opened job
        const jobKey = job?.id || job?.job_id || job?.url || `${job?.title || ''}::${job?.company_name || job?.company || ''}`;

        const fetchjobMatchData = async () => {
            try {
                setMatchLoading(true);
                const response = await axios.post(`/user/score-resume-job-match/`, job, {
                    headers: { 'x-access-token': localStorage?.getItem('token') }
                });
                successSetter("Job match data analyzed successfully.");
                setResumeScore(response.data.resumeJobScore);
            } catch (error) {
                console.log(error)
                if (error?.response && error.response.status === 403) {
                    setResumeScore(error.response.data.resumeJobScore)
                    errorSetter(error.response.data.error || "Access forbidden. Please upgrade to Monthly.");
                    setPricingOpen(true)
                    setSubbedForResumeScore(false)
                } else {
                    errorSetter("Failed to fetch job match data.");
                }
            } finally {
                setMatchLoading(false);
            }
        }

        const resumeJobScore = job?.insights?.resumeJobScore;

        // If the job already includes precomputed score, use it and mark as fetched
        if (Array.isArray(resumeJobScore) && resumeJobScore.length > 0) {
            setResumeScore(resumeJobScore);
            if (jobKey) fetchedForJobRef.current = jobKey;
            return;
        }

        // If no jobKey or we've already fetched for this job, skip
        if (!jobKey) return;
        if (fetchedForJobRef.current === jobKey) return;

        // Mark and fetch once
        fetchedForJobRef.current = jobKey;
        fetchjobMatchData();

    }, [job, errorSetter, successSetter])

    // Helper: Get company name and LinkedIn URL from job object
    const getCompanyInfo = () => ({
        companyName: job?.company_name || job?.company,
        companyLinkedInUrl: job.company_linkedin || job?.company_object?.linkedin_url || job?.company_url
    });

    // 1. Initiate Insight (Step 1)
    const initiateInsight = async () => {
        if (!companyInsight || Object.keys(companyInsight).length > 0) {
            return;
        }
        if(snapshotId) return; // Do not initiate if already in progress
        setInsightLoading(true);
        setCompanyInsight({});
        setSnapshotId(null);

        let { companyName, companyLinkedInUrl } = getCompanyInfo();
        // Allow initiating when at least a company name OR some company URL/domain is present.
        if (!companyName && !companyLinkedInUrl) {
            errorSetter("Missing company name or LinkedIn URL.");
            setInsightLoading(false);
            return;
        }

        // If still no URL, but job.url or external_url exists, use them
        if (!companyLinkedInUrl) {
            companyLinkedInUrl = job?.external_url || job?.final_url || job?.company_url || job?.url || null;
        }

        try {
            const res = await axios.post(
                '/user/initiate-company-insight',
                { companyName, companyLinkedInUrl },
                { headers: { 'x-access-token': localStorage.getItem('token') } }
            );
            // If cached, you'll get companyDetails immediately
            if (res.data.companyDetails) {
                setCompanyInsight(res.data.companyDetails);
                setInsightLoading(false);
                successSetter("Company insights loaded!");
                setSnapshotId(null);
                return;
            }
            // Otherwise, get snapshot_id and start polling
            setSnapshotId(res.data.snapshot_id);
            infoSetter("Started searching the web for insights, please wait...");
            pollInsightStatus(res.data.snapshot_id, companyName, companyLinkedInUrl);
        } catch (err) {
            if (err.response && err.response.status === 403) {
                errorSetter(err.response.data.error || "Access forbidden. Please upgrade to Monthly.");
                setSubbedForInsight(false)
            }
            errorSetter(err?.response?.data?.error || "Failed to initiate insight.");
            setInsightLoading(false);
        } 
    };

    // 2. Poll Status (Step 2)
    const pollInsightStatus = (snapshot_id, companyName, companyLinkedInUrl) => {
        let pollAttempts = 0;
        const maxPolls = 24; // ~120 seconds max
        const pollInterval = 5000; // 5 seconds

        const poll = async () => {
            try {
                const res = await axios.get(
                    `/user/poll-company-insight-status?snapshot_id=${snapshot_id}`,
                    { headers: { 'x-access-token': localStorage.getItem('token') } }
                );
                if (res.data.status === "ready") {
                    downloadInsightResult(snapshot_id, companyName, companyLinkedInUrl);
                } else if (res.data.status === "failed") {
                    errorSetter("Insight process failed.");
                    setInsightLoading(false);
                    setSnapshotId(null);
                } else if (pollAttempts < maxPolls) {
                    infoSetter("Still harvesting insights across the web...");
                    pollAttempts++;
                    setTimeout(poll, pollInterval);
                } else {
                    errorSetter("Insight process timed out. Please try again later.");
                    setInsightLoading(false);
                    setSnapshotId(null);
                }
            } catch (err) {
                errorSetter("Error polling insight status.");
                setInsightLoading(false);
                setSnapshotId(null);
            }
        };
        poll();
    };

    // 3. Download Result (Step 3)
    const downloadInsightResult = async (snapshot_id, companyName, companyLinkedInUrl) => {
        try {
            const res = await axios.get(
                `/user/download-company-insight-result?snapshot_id=${snapshot_id}&companyName=${encodeURIComponent(companyName)}&companyLinkedInUrl=${encodeURIComponent(companyLinkedInUrl)}`,
                { headers: { 'x-access-token': localStorage.getItem('token') } }
            );
            setCompanyInsight(res.data.companyDetails);
            setInsightLoading(false);
            successSetter("Company insights loaded!");
            setSnapshotId(null);
        } catch (err) {
            errorSetter("Failed to download company insights.");
            setInsightLoading(false);
            setSnapshotId(null);
        }
    }; 

    const handleMessageCompany = () => {
        if (isResumeSubbed && resumeSubDuration === "Per Month") {
            window.open(job?.company_url || job?.company_object?.linkedinurl, '_blank', 'noopener,noreferrer');
        } else {
            errorSetter("PER MONTH users only, redirecting to pricing.");
            setPricingOpen(true)
        }
    }

    // --- Try Again / Retry single-job auto-apply handlers (mirrors CompletedApplications) ---
    const startRetry = async (jobId, manualEmailArray = null, forceSend = false) => {
        try {
            setRetryingJob(jobId);
            // Validate manual emails (if any) and build manualEmails map
            const manualMap = {};
            if (manualEmailArray) {
                // ensure it's an array already (caller should pass array)
                manualMap[jobId] = Array.isArray(manualEmailArray) ? manualEmailArray : [String(manualEmailArray).trim()];
            }
            const respData = await startAutoApply({ selectedJobIds: [jobId], manualEmailsMap: Object.keys(manualMap).length ? manualMap : undefined, forceSend });
            const batchId = respData?.batchId || respData?.batchID || null;
            try { window.dispatchEvent(new CustomEvent('tryAgain:start', { detail: { message: 'Retrying application...', batchId } })); } catch(_) {}
        } catch (e) {
            const resp = e?.response;
            if (resp && (resp.data?.status === 'quota_exceeded' || (resp.status === 403 && resp.data?.openPricing))) {
                try { window.dispatchEvent(new CustomEvent('openResumePricing')); } catch(_) {}
            }
            setRetryingJob(null);
            try { window.dispatchEvent(new CustomEvent('tryAgain:stop')); } catch(_) {}
        }
    };

    const ensureGmailThenStart = async (jobObj, manualEmail) => {
        // manual retries should force sending even if a send-lock exists
        const forceSend = true;
        const isAuth = localStorage.getItem('token');
        try {
            const r = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': isAuth }});
            const { isGmail, granted } = r.data || {};
            if (isGmail && !granted) {
                // open popup flow similar to CompletedApplications
                try {
                    const s = await axios.get('/user/gmail/oauth/start?mode=popup', { headers: { 'x-access-token': isAuth }});
                    const gmailAuthUrl = s?.data?.authUrl;
                    if (gmailAuthUrl) {
                        const w = 520, h = 640;
                        const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
                        const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
                        const win = window.open(gmailAuthUrl, 'gmail-oauth', `width=${w},height=${h},left=${x},top=${y},resizable=yes,scrollbars=yes,status=yes`);
                        if (!win || win.closed || typeof win.closed === 'undefined') {
                            window.location.href = gmailAuthUrl;
                            return;
                        }
                        const handler = (ev) => {
                            try {
                                if (ev && ev.data && ev.data.type === 'gmail_connected') {
                                    window.removeEventListener('message', handler);
                                    startRetry(String(jobObj.jobId || jobObj.job_id || jobObj.id), manualEmail, forceSend);
                                }
                            } catch {};
                        };
                        window.addEventListener('message', handler);
                        return;
                    }
                } catch (_) {
                    // fallthrough to start without gmail
                }
            }
        } catch (_) {}
        // proceed if not gmail or already granted
        startRetry(String(jobObj.jobId || jobObj.job_id || jobObj.id), manualEmail, forceSend);
    };

    // Defensive: if job is missing (e.g., list reloaded and index invalid), render a safe placeholder
    if (!job) {
        return (
            <JobViewStyled theme={themeName}>
                <span className="header">
                    <h1 className="sectionTitle">Job Information</h1>
                    <button onClick={()=> setActiveIndex(null)}>
                        <MdOutlineCancel color='crimson'/>
                    </button>
                </span>
                <RuleStyled />
                <OverflowContainerStyled>
                    <div style={{ padding: 16, color: 'rgba(0,0,0,0.6)' }}>
                        Job details are unavailable. Please select a job from the list.
                    </div>
                </OverflowContainerStyled>
            </JobViewStyled>
        );
    }

    return (
        <JobViewStyled theme={themeName}>
            <span ref={headerAnchorRef} className="header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, position: 'relative' }}>
                    <h1 className="sectionTitle">Job Information</h1>
                    {(job?.applied || job?.attemptedEmailAutoApply) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div ref={el => { if (el) badgeAnchorRef.current = el; }} style={{ display: 'flex', alignItems: 'center' }}>
                                <PillBadge
                                    label={job?.applied ? 'Applied' : 'Attempted'}
                                    variant={job?.applied ? 'applied' : 'attempted'}
                                    theme={themeName}
                                    compact={true}
                                />
                            </div>
                            <TutorialPopover
                                show={showTip}
                                tipId={job?._id ? `job-badge-${job._id}` : null}
                                title={job?.applied ? 'Applied — What next?' : 'Attempted — Retry or review'}
                                description={job?.applied ? 'This job was applied to on your behalf via Email Auto-Apply. You can also use AI‑Assisted Apply button to further increase your chances.' : 'An Email Auto-Apply attempt was made for this job. View the completed application to retry or use AI-Assisted Apply to use form application.'}
                                anchorRect={badgeRect || headerRect}
                                direction='bottom'
                                theme='auto'
                                primaryLabel={job?.applied ? 'AI‑Assisted Apply' : 'View Application'}
                                onClose={() => setShowTip(false)}
                                onPrimary={() => {
                                    try {
                                        setShowTip(false);
                                        if (job?.applied) {
                                            const linkUrl = job?.linkedin_url || job?.company_object?.linkedin_url || job?.url || job?.company_url || '';
                                            const companySite = job?.external_url || job?.final_url || '';
                                            getJob(linkUrl, companySite, job?.applicants_count, job);
                                        } else {
                                            window.location.href = '/user/dashboard/auto-apply';
                                        }
                                    } catch (e) {}
                                }}
                            />
                        </div>
                    )}
                </div>

                <button onClick={()=> setActiveIndex(null)}>
                    <MdOutlineCancel color='crimson'/>
                </button>
            </span>

            <RuleStyled />

            <OverflowContainerStyled ref={overflowRef}>
                <div className="sectionOne">
                    <div className="firstLayer">
                        <ImageAltStyled theme={themeName}>
                            {(job?.company_object?.logo || job?.company_logo) ? (
                                <img
                                    src={job.company_object?.logo || job?.company_logo}
                                    alt={job?.company_name || job?.company || "Company Logo"}
                                />
                            ) : (
                                <h1>{job?.company_name?.charAt(0) || job?.company?.charAt(0)}</h1>
                            )}
                        </ImageAltStyled>
                        <span className="jobRoleNCompany">
                                <h1>{job?.title || job?.job_title}</h1>
                                <p><span>{job?.company_name || job?.company}</span></p>
                            </span>
                    </div>
                    <span className="secondLayer">
                        {(job?.country || job?.location) && (
                            <p>
                                {(job?.country || job?.location)?.split(",").slice(0, 1).join(" ")}
                            </p>
                        )}
                        <p>{job?.employment_type || job?.job_type}</p>
                        <p>{job?.remote ? "remote" : job?.hybrid ? "hybrid" : "on-site"}</p>
                        <p>{job?.seniority}</p>
                        {(job?.salary || job?.salary_string) && <p>{job?.salary || job?.salary_string}</p>}
                        <p>{job?.time_posted || job?.date_posted}</p>
                    </span>
                </div>

                <div className="aiLinks">
                    <h3 className="sectionTitle">Ai Action Links</h3>
                    <div className="actionButtons">
                        {/* Try Again button shown when an email auto-apply was attempted earlier */}
                        {job?.attemptedEmailAutoApply && !job?.applied && (
                            <button
                                className="items tryAgain"
                                onClick={() => {
                                    if (retryingJob) return;
                                    // Always open manual-email modal (consistent with CompletedApplications)
                                    setEmailInput('');
                                    setEmailModalOpen(true);
                                }}
                                title="Try email apply again"
                            >
                                <SiGmail />
                                Try Again
                            </button>
                        )}
                        <button
                            className="items getJob"
                            onClick={() => {
                                const linkUrl = job?.linkedin_url || job?.company_object?.linkedin_url || job?.url || job?.company_url || '';
                                const companySite = job?.external_url || job?.final_url || '';
                                getJob(linkUrl, companySite, job?.applicants_count, job);
                            }}
                        >
                            <FaHandshake/>
                            AI-Assisted Apply
                        </button>
                        <button
                            className="items getResume"
                            onClick={() => getResume(job?.description, job?.title || job?.job_title)}
                        >
                            <SiReaddotcv/>
                            Optimize Resume
                        </button>
                        <button
                            className="items getCover"
                            onClick={() => chooseActStr("Cover Letter", job)}
                        >
                            <SlEnvolopeLetter/>
                            Cover Letter
                        </button>
                        <button
                            className="items followUp"
                            onClick={() => chooseActStr("Email", job)}
                        >
                            <MdMarkEmailRead/>
                            Follow up
                        </button>

                        <button
                            className="items prep"
                            onClick={() => chooseActStr("Interview", job)}
                        >
                            <TbChecklist/>
                            Interview Prep
                        </button>

                        <button
                            className="items messageRecruiter"
                            onClick={handleMessageCompany}
                            aria-label={`Message ${job?.company_name || job?.company_object?.name}`}
                        >
                            <SiAnswer/>
                            Message Recruiter
                        </button>

                        <button
                            className="items deleteJob"
                            onClick={async (e) => {
                                if (deleting) return;
                                try {
                                    const cs = window.getComputedStyle(e.currentTarget);
                                    const bc = cs.borderColor || 'crimson';
                                    setDeleteBorderColor(bc);
                                } catch(_) { /* ignore */ }
                                setDeleting(true);
                                try {
                                    const res = await deleteJob(job?.id, job?.title || job?.job_title);
                                    // If cancelled, keep UI intact
                                    if (!res || res.cancelled) return;
                                } finally {
                                    setDeleting(false);
                                }
                            }}
                        >
                            {deleting ? (
                                <OvalSpinner size={14} color={deleteBorderColor} />
                            ) : (
                                <>
                                    <MdDeleteForever/>
                                    Delete
                                </>
                            )}
                        </button>


                    </div>

                </div>

                <div className="jobSuitability">
                    <h3 className="sectionTitle">Is this Job for me ?</h3>
                    <br />
                    <p>Click <strong>Optimize Resume</strong> button above to improve resume score for this job</p>
                    {!subbedForResumeScore && (
                        <div>
                            <p>Upgrade your plan to Per Month to enjoy unlimited deep insights</p>
                            <br />
                            <ButtonThin onClick={() => setPricingOpen(true)} width={'120px'} height='30px' color='#EE7B1C'>
                                unlock now &nbsp; <IoIosUnlock />
                            </ButtonThin>
                        </div>
                    )}
                    <div className="dataSection">
                        {resumeScore.map((item, index) => (
                            <SuitabilitySpanStyled theme={themeName} matched={item.title === "Resume Match"} className="suitabilityItems" key={index}>
                                {matchLoading ? (
                                                    <ThreeCircles
                                                        height="50"
                                                        width="50"
                                                        innerCircleColor="#F8E231"
                                                        middleCircleColor="#987070"
                                                        outerCircleColor="#7CC9CC"
                                                        wrapperClass=""
                                                        visible={true}
                                                        ariaLabel="three-circles-rotating"
                                                    />
                                                ) : <p>{item.percentage}<span className="percent">%</span></p>}
                                <p>{item.title}</p>

                            </SuitabilitySpanStyled>

                        ))}

                    </div>


                </div>

                <div className="insights">
                    <h1>Deep Insights</h1>
                    
                    <div className="insightsConnects">
                        <Accordion
                            job={job}
                            loading={insightLoading}
                            data={{
                                title: "Insider Connect",
                                items: companyInsight?.employees ? companyInsight.employees : []
                            }}
                            subbedForInsight={subbedForInsight}
                            open={insiderOpen}
                            onToggle={() => {
                                if (!insiderOpen) {
                                    initiateInsight();
                                }
                                setInsiderOpen((prev) => !prev);
                                setCompanyOpen(false);
                            }}
                        />
                    </div>
                    <div className="insightsConnects">
                        <Accordion
                            loading={insightLoading}
                            data={{
                                title: "Company Insights",
                                items: companyInsight ? companyInsight : {}
                            }}
                            subbedForInsight={subbedForInsight}
                            open={companyOpen}
                            onToggle={() => {
                                if (!companyOpen) {
                                    initiateInsight();
                                }
                                setCompanyOpen((prev) => !prev);
                                setInsiderOpen(false);
                            }}
                        />
                    </div>
                </div>


                <div className="summary">
                    <h2>Job Description</h2>
                    <div>
                        {job?.description ? formatLargeText(job.description) : <em>No description available.</em>}
                    </div>
                </div>
            </OverflowContainerStyled>

            {pricingOpen && (
                <ResumePricing open={pricingOpen} closePricing={() => setPricingOpen(false)} />
            )}
            {emailModalOpen && (
                <PlainModalOverlay>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <div className='prev-page' onClick={() => { setEmailModalOpen(false); setEmailInput(''); }}>
                            <FaLongArrowAltLeft />
                        </div>
                        <h4 style={{ color: '#3E8F93', marginBottom: 10 }}>No recruiter found</h4>
                        <p style={{ fontSize: '.9rem', opacity: .9, margin: '6px auto', maxWidth: 520 }}>This recruiter prevented email fetching or email not available. Use the query below on Google search to get the email if available.</p>

                        {(() => {
                            try {
                                const company = (job?.company_domain || job?.company_object?.domain || job?.company_name || job?.company || '').trim() || 'the company';
                                const query = `${company} career or contact email`;
                                return (
                                    <div style={{ margin: '8px 0' }}>
                                        <div
                                            role="button"
                                            onClick={async () => {
                                                try {
                                                    await copyText(query);
                                                    successSetter('Copied');
                                                } catch (e) {
                                                    try { errorSetter('Failed to copy'); } catch(_) {}
                                                }
                                            }}
                                            title="Tap to copy"
                                        >
                                            <Alert
                                                sx={{ mb: 1, fontSize: '.85rem', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
                                                severity="warning"
                                            >
                                                <strong style={{ flex: 1 }}>{query}.</strong>
                                                <FaRegCopy size={14} style={{ flex: '0 0 auto' }} />
                                            </Alert>
                                        </div>
                                    </div>
                                );
                            } catch {
                                return null;
                            }
                        })()}

                        <div style={{ width: '100%', marginTop: 8 }}>
                            <AuthInput
                                id="manualEmail"
                                name="manualEmail"
                                value={emailInput}
                                label="Recruiter or careers email (optional, 2 max, comma separated)"
                                inputType="email"
                                inputGridSm={12}
                                onChange={(e) => setEmailInput(e.target.value)}
                                mb={2}
                            />
                        </div>
                        <div style={{ width: '100%', marginTop: 12 }}>
                            <ButtonSubmitGreen
                                onClick={() => {
                                    const raw = (emailInput || '').trim();
                                    const { valid, invalid } = parseAndValidateEmails(raw);
                                    if (invalid && invalid.length) { try { errorSetter(`Invalid email(s): ${invalid.join(', ')}`); } catch(_) {} return; }
                                    if (raw && (!valid || valid.length === 0)) { try { errorSetter('No valid email found.'); } catch(_) {} return; }
                                    setEmailModalOpen(false);
                                    try { window.dispatchEvent(new CustomEvent('tryAgain:start', { detail: { message: 'Retrying application...' } })); } catch(_) {}
                                    ensureGmailThenStart({ jobId: job?.id || job?.job_id || job?.jobId || job?.id }, valid.length ? valid : null);
                                }}
                            >
                                Start
                            </ButtonSubmitGreen>
                        </div>
                    </div>
                </PlainModalOverlay>
            )}
        </JobViewStyled>

    );

}

export default JobView;